import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import messages from '../../../../utils/translationMessages';
import { setGenericEvent, clearEcommerceData } from '../../../../store/actions/dataLayer';

const DealerLocation = ({
  intl,
  dealer,
  dealerIndex,
  setDealerIndex,
  setGenericEvent,
  clearEcommerceData,
}) => {
  const { formatMessage: t } = intl;
  const onClick = () => {
    clearEcommerceData();
    setGenericEvent('select a dealer', 'click',  dealer.companyName, dealer.dealerId, 'find a dealer', `DealerID,${dealer.dealerId}`);
    setDealerIndex(dealerIndex);
  };

  return (
    <>
      <div className="col-1">
        <div className="rank">
          <strong>{dealerIndex + 1}</strong>
        </div>
        <div className="distance">
          {dealer.distance?.map((term, key) => (
            <p key={key}>{term}</p>
          ))}
        </div>
      </div>
      <div className="col-2">
        <h3>{dealer.companyName}</h3>
        <address className="location">{dealer.location}</address>
        <button className={`dealer-${dealerIndex}`} onClick={onClick}>
          {t(messages.dealerLocatorModal.viewDealerInfo)}
        </button>
      </div>
    </>
  );
};

DealerLocation.propTypes = {
  dealer: PropTypes.any.isRequired,
  dealerIndex: PropTypes.number.isRequired,
  setDealerIndex: PropTypes.func.isRequired,
  setGenericEvent: PropTypes.func.isRequired,
  clearEcommerceData: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default connect(
  null,
  (dispatch) => bindActionCreators({
    setGenericEvent,
    clearEcommerceData,
  }, dispatch)
)(injectIntl(DealerLocation));
